import { STATUS } from "@/constants/statuses";
import type { Observable } from "rxjs";
import { combineLatest, map } from "rxjs";

/**
 * Function to determine loading status.
 * @param {STATUS} status
 */
export const getLoadingStatus = (status: STATUS): STATUS =>
    status === STATUS.VIRGIN ? STATUS.INITIAL_LOADING : STATUS.LOADING;

export const isVirginStatus = (status: STATUS): boolean =>
    status === STATUS.VIRGIN;

/**
 * Combines multiple observable statuses and checks if any of them match the specified status.
 *
 * @param {Array<Observable<STATUS>>} statuses - An array of observables emitting `STATUS` values.
 * @param {STATUS} status - The status to check for in the combined observable statuses.
 * @returns {Observable<boolean>} An observable that emits `true` if any of the statuses match the specified status, otherwise `false`.
 */
export const selectRequestStatus = (
    statuses: Array<Observable<STATUS>>,
    status: STATUS
): Observable<boolean> =>
    combineLatest(statuses).pipe(map((statuses) => statuses.includes(status)));
